import React from "react";

import { Module } from "@com.mgmtp.a12.client/client-core/lib/core/application";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";

import { showArchiveDialogSaga } from "./sagas/showArchiveDialogSaga";
import { revokeArchiveUrlBeforeCancelMiddleware } from "./middleware/revokeArchiveUrlBeforeCancelMiddleware";
import { EldoradoCancelModal } from "./components/eldoradoCancelModal";
import {
	cancelEldoradoArchiveRemoteSaga,
	cancelEldoradoArchiveSaga,
	handleArchiveCancelRequestedSaga
} from "./sagas/cancelEldoradoArchiveSaga";
import { sendEldoradoArchiveSaga } from "./sagas/sendEldoradoArchiveSaga";
import { generateEldoradoArchiveSaga } from "./sagas/generateEldoradoArchiveSaga";
import { generateXakteArchiveSaga } from "./sagas/generateXakteArchiveSaga";
import { ArchiveFormEngine } from "./components/ArchiveFormEngine";
import { archiveModuleFormDataProvider } from "./provider/archiveDataprovider";

const eldoradoArchivalModule = (): Module => ({
	id: "moduleEldoradoArchival",
	views: () => viewComponentProvider,
	sagas: () => [
		showArchiveDialogSaga,
		generateEldoradoArchiveSaga,
		generateXakteArchiveSaga,
		sendEldoradoArchiveSaga,
		cancelEldoradoArchiveSaga,
		cancelEldoradoArchiveRemoteSaga,
		handleArchiveCancelRequestedSaga
	],
	dataProviders: () => [archiveModuleFormDataProvider],
	middlewares: () => [revokeArchiveUrlBeforeCancelMiddleware]
});

const components: { [name: string]: React.ComponentType<View> | undefined } = {
	EldoradoCancelModal,
	ArchiveFormEngine
};

function viewComponentProvider(name: string) {
	return components[name];
}

export default eldoradoArchivalModule;
